<template>
	<div>
		<v-autocomplete
				v-model="model"
				:items="entries"
				:loading="is_loading"
				:search-input.sync="search"
				hide-no-data
				hide-selected
				item-text="label"
				item-value="isbn"
				label="ISBN, Title, Author"
				placeholder="Start typing to search"
				return-object
				attach
				:outline="is_mobile"
				solo
				flat
				@input="onInput"
				class="h-contact-us-input"
		>
		</v-autocomplete>
	</div>
</template>

<script>
	import Axios from 'axios';
	import _ from 'lodash';

	export default {
		name: "SearchBook",

		props: {
			showAll: {
				type: Boolean,
				default: false
			}
		},

		data() {
			return {
				entries: [],
				is_loading: false,
				model: null,
				search: null
			};
		},

		watch: {
			'search': _.debounce(function (val) {
				const self = this;
				// this.entries = [];

				if (!val) {
					self.model = null;
					return;
				}

				if (val.length < 3 || self.model) {
					return;
				}

				self.is_loading = true;
				Axios.get('/service/customer_help/rest/index.php/customer_help/search_books?q=' + val).then(function (response) {
					if (response.status === 200 && response.data && response.data['status'] === 'success') {
						let ent = _.map(response.data['data']['items'], function (x) {
							x['label'] = `${x['isbn']}, ${x['title']}` + (x['author'] ? `, by ${x['author']}` : '');
							return x;
						});

						if (self.showAll) {
							ent.unshift({
								label: `Show All Results for (${val})`,
								isbn: '-1',
							});
						}

						self.entries = ent;
					}
				}).finally(function (x) {
					self.is_loading = false;
				});

			}, 300)
		},
		methods: {
			onInput() {
				this.$emit('selected', {
					query: this.search,
					result: this.model,
				});
			}
		}


	}
</script>

<style scoped>

</style>